<div class="main-container" *ngIf="documentsList$ | withLoading | async as documentsList">
    <ng-template [ngIf]="documentsList.value">
        <div class="controls">
            <div class="buttons">
                <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="emitShowDocumentUploadDialog()" *appTableAccess="[tableCreateAccessObj]">
                    <mat-icon class="material-icons-outlined" aria-hidden="true">add</mat-icon> 
                    {{ 'Add' | translate: {Default: "Add"} }}
                </button>
                <button mat-flat-button appPreventDoubleClick (throttledClick)="emitShowCreateNewDirectoryForm()" *appTableAccess="[tableCreateAccessObj]" [attr.aria-label]="'AddADirectory' | translate: {Default: 'Add a Directory'}">
                    <mat-icon class="material-icons-outlined" aria-hidden="true">create_new_folder</mat-icon> 
                </button>
            </div>
        </div>
        
        <div class="tree-container">
            <kendo-treeview
                [nodes]="documentsList.value"
                [textField]="['name']"
                kendoTreeViewExpandable
                [(expandedKeys)]="expandedKeys"
                [hasChildren]="hasChildren"
                [children]="fetchChildren"
                kendoTreeViewDragAndDrop
                kendoTreeViewDragAndDropEditing
                kendoTreeViewHierarchyBinding
                (nodeDrop)="handleDrop($event)"
                [attr.aria-label]="'Documents' | translate: {Default: 'Documents'}"
            >
                <ng-template kendoTreeViewNodeTemplate let-dataItem>
                    <div class="details-container" *ngIf="dataItem.isFolder" [attr.data-element-id]="dataItem.id">
                        <!-- <mat-icon class="folder-icon" class="material-icons-outlined">folder</mat-icon>  -->
                        <img 
                            class="ms-icon" 
                            src="assets/icons/folder.svg" 
                            aria-hidden="true"
                            style="width: 30px;
                                    height: 30px;
                                    vertical-align: middle;"> 
                        
                        <div class="document-label-top">
                            {{ dataItem.name }}
                        </div>
                        <div class="controls-container">
                            <button mat-icon-button [matMenuTriggerFor]="menu" class="actions-btn" [attr.aria-label]="('FolderActions' | translate: {Default: 'Actions for'}) + ' ' + dataItem.name">
                                <mat-icon 
                                    setColor 
                                    [setColorRules]="[
                                    {
                                        color: 'primaryColour',
                                        events: ['hover']
                                    }
                                    ]"
                                    class="material-icons-outlined"
                                    aria-hidden="true"
                                >more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item appPreventDoubleClick (throttledClick)="emitEditEvent(dataItem)" *appTableAccess="[tableUpdateAccessObj]">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">edit</mat-icon> 
                                    <span>{{ 'Edit' | translate: {Default: "Edit"} }}</span>
                                </button>
                                <button mat-menu-item appPreventDoubleClick (throttledClick)="emitDeleteEvent(dataItem)" *appTableAccess="[tableDeleteAccessObj]">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">delete</mat-icon> 
                                    <span>{{ 'Delete' | translate: {Default: "Delete"} }}</span>
                                </button>
                                <button mat-menu-item appPreventDoubleClick (throttledClick)="emitShowCreateNewDirectoryForm(dataItem)" *appTableAccess="[tableCreateAccessObj]">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">create_new_folder</mat-icon> 
                                    <span>{{ 'AddADirectory' | translate: {Default: "Add a Directory"} }}</span>
                                </button>
                                <button mat-menu-item appPreventDoubleClick (throttledClick)="emitShowDocumentUploadDialog(dataItem)" *appTableAccess="[tableCreateAccessObj]">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">note_add</mat-icon> 
                                    <span>{{ 'UploadAFile' | translate: {Default: "Upload a File"} }}</span>
                                </button>
                            </mat-menu>    
                        </div>
                    </div>
                    <div *ngIf="!dataItem.isFolder">
                        <div class="details-container" [attr.data-element-id]="dataItem.id">
                            <ng-container *ngIf="icons[dataItem.contentType]; else blankIcon">
                                <img 
                                    class="ms-icon" 
                                    src={{icons[dataItem.contentType]}} 
                                    aria-hidden="true"
                                    style="width: 30px;
                                            height: 30px;
                                            vertical-align: middle;"> 
                            </ng-container>
                            <ng-template #blankIcon>
                                <mat-icon class="blank-document-icon material-icons-outlined">description</mat-icon>
                            </ng-template>
                            <div class="document-label">
                                <div class="document-label-top">
                                    <div class="title" tabindex="0" appPreventDoubleClick (throttledClick)="emitViewFileEvent(dataItem)" (keydown.enter)="emitViewFileEvent(dataItem)">{{dataItem.name}}</div>
                                    <div class="filesize">{{dataItem.fileLength | filesize }}</div>
                                </div>
                                <div class="document-label-bottom">
                                    Created {{dataItem.version.createdOn | date:'longDate'}} by <span setColor [setColorRules]="[ { color: 'primaryColour', events: ['hover'] } ]" class="clickable-icon" routerLink="{{routes.TALENT_TRACK}}{{routes.EDIT}}/{{dataItem.version.createdBy.id}}">{{dataItem.version.createdBy.firstName}} {{dataItem.version.createdBy.lastName}}</span>
                                </div>
                            </div>
                            <div class="controls-container">
                                <button mat-icon-button [matMenuTriggerFor]="menu" class="actions-btn" [attr.aria-label]="('FileActions' | translate: {Default: 'Actions for'}) + ' ' + dataItem.name">
                                    <mat-icon 
                                        setColor 
                                        [setColorRules]="[
                                        {
                                            color: 'primaryColour',
                                            events: ['hover']
                                        }
                                        ]"
                                        class="material-icons-outlined"
                                        aria-hidden="true"
                                    >more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item appPreventDoubleClick (throttledClick)="emitDeleteEvent(dataItem)" *appTableAccess="[tableDeleteAccessObj]">
                                        <mat-icon class="material-icons-outlined" aria-hidden="true">delete</mat-icon> 
                                        <span>{{ 'Delete' | translate: {Default: "Delete"} }}</span>
                                    </button>
                                    <button mat-menu-item appPreventDoubleClick (throttledClick)="emitDownloadEvent(dataItem)">
                                        <mat-icon class="material-icons-outlined" aria-hidden="true">download</mat-icon> 
                                        <span>{{ 'Download' | translate: {Default: "Download"} }}</span>
                                    </button>
                                </mat-menu>    
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template
                    kendoTreeViewDragClueTemplate
                    let-action="action"
                    let-destinationItem="destinationItem"
                    let-text="text"
                    let-sourceItem="sourceItem"
                >
                    <div class="drag-clue-template">
                        <span
                            class="k-drag-status k-icon"
                            [ngClass]="getDragStatus(action, destinationItem)"
                        ></span>
                        <span *ngIf="sourceItem">{{ sourceItem.item.dataItem.name }}</span>
                    </div>
                </ng-template>
            </kendo-treeview>
        </div>
    </ng-template>
    <ng-template [ngIf]="documentsList.error">Error {{ obs.error }}</ng-template>
    <ng-template [ngIf]="documentsList.loading">
        <ngx-skeleton-loader
            count="5"
            [theme]="{ 
                'height.px': 50
            }"
        ></ngx-skeleton-loader>
    </ng-template>
</div>

